import { gql } from '@apollo/client';

const FETCH_AAP_USER_INFORMATION = gql`
    query fetchAapUserInformation {
        fetchAapUserInformation {
            aapEligibility
        }
    }
`;

const FETCH_BASIC_USER_INFORMATION = gql`
    query fetchBasicUserInformation {
        fetchBasicUserInformation {
            userId,
            userInformation {
                firstName,
                lastName,
                asciiFirstName,
                asciiLastName,
                email,
                phoneNumber,
                phoneCountryCode,
                hasExistingProperties
            }
        }
    }
`;

const IS_PAPER_CONTRACT_USER = gql`
    query isEpcPaperContractUser {
        isEpcPaperContractUser
    }
`;

export {
    FETCH_AAP_USER_INFORMATION,
    IS_PAPER_CONTRACT_USER,
    FETCH_BASIC_USER_INFORMATION
};
